var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 13.5 12.3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.35 11.55H9.15M6.75 9.15V11.55M1.95 0.75H11.55C12.2127 0.75 12.75 1.28726 12.75 1.95V7.95C12.75 8.61274 12.2127 9.15 11.55 9.15H1.95C1.28726 9.15 0.75 8.61274 0.75 7.95V1.95C0.75 1.28726 1.28726 0.75 1.95 0.75Z",
    stroke: "var(--stroke-0, #9698A3)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.6c936b3cf8b03c08a50415162a0a6aa2.svg";
export { ForwardRef as ReactComponent };